export default {
  required: value => !!value || 'Обязательное поле.',
  counter: value => value ?.length >= 6 || 'Минимум 6 символов',
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Неверный e-mail.'
  },
  positive: value => (value || 0) <= 0 || `Значение не должно быть = [${value}].`,
}